import React, { useState } from 'react'
import ReactQuill from 'react-quill'

export default function TextArea({ rows, className, maxLength, areaProps }) {
  const [isActive, setIsActive] = useState(false)

  // Handle focus for the entire container (editor + toolbar)
  const handleFocus = () => {
    setIsActive(true)
  }

  const handleBlur = e => {
    // Only deactivate if focus actually leaves the container
    if (!e.relatedTarget || !e.currentTarget.contains(e.relatedTarget)) {
      setIsActive(false)
      if (areaProps && typeof areaProps.onBlur === 'function') {
        areaProps.onBlur(e)
      }
    }
  }

  // Handle change from ReactQuill
  const handleChange = (content, delta, source, editor) => {
    if (source === 'user' && typeof areaProps.onChange === 'function') {
      areaProps.onChange(content)
    }
  }

  const wrapperClass = `${className} custom-rte ${isActive ? 'active' : 'inactive'}`

  return (
    <div
      className={wrapperClass}
      data-color-mode="light"
      onFocus={handleFocus}
      onBlur={handleBlur}
      tabIndex="-1" // Allow div to catch focus if needed/for safety
    >
      <ReactQuill
        theme="snow"
        value={areaProps.value ?? ''}
        onChange={handleChange}
        modules={{
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
          ],
        }}
      />
    </div>
  )
}
